import { createSelector, createSlice } from '@reduxjs/toolkit';

const colorModeSlice = createSlice({
    name: 'colorMode',
    initialState: {
        value: 'light', // Initial color mode
        sidebarOpen: false,
        globalLoader: false,
    },
    reducers: {
        setColorMode: (state, action) => {
            return { ...state, value: action.payload };
        },
        toggleSideBar: (state, action) => {
            return { ...state, sidebarOpen: action.payload };
        },

        startGlobalLoading: (state) => {
            state.globalLoader = true;
        },
        stopGlobalLoading: (state) => {
            state.globalLoader = false;
        }
    },
});

export const { setColorMode, toggleSideBar, startGlobalLoading, stopGlobalLoading } = colorModeSlice.actions;


export const selectColorMode = createSelector(
    state => state.colorMode,
    colorMode => colorMode.value
);

export const selectSidebar = createSelector(
    state => state.colorMode,
    colorMode => colorMode.sidebarOpen
);

export const globalLoaderSelector = createSelector(
    state => state.colorMode,
    colorMode => colorMode.globalLoader
)


export default colorModeSlice.reducer;
